'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reducer = undefined;

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _reduxReducer = require('./redux-reducer');

Object.defineProperty(exports, 'reducer', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_reduxReducer).default;
    }
});

var _reactRedux = require('react-redux');

var _VideoAsset = require('./VideoAsset');

var _VideoAsset2 = _interopRequireDefault(_VideoAsset);

var _reduxActions = require('./redux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, _ref) {
    var reduxPath = _ref.reduxPath;

    var videoState = (0, _get3.default)(state, reduxPath, state);
    return {
        currentVideoNodeId: videoState.currentVideoNodeId,
        currentVideoStartMode: videoState.currentVideoStartMode,
        fetchedVideos: videoState.videos
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var reduxPath = _ref2.reduxPath,
        apiUrl = _ref2.apiUrl;
    return {
        onVideoStarted: function onVideoStarted(nodeId, startMode) {
            return dispatch((0, _reduxActions.playVideo)(nodeId, startMode));
        },
        fetchVideo: function fetchVideo(videoId) {
            if (!apiUrl) return undefined;
            return dispatch((0, _reduxActions.fetchVideo)(videoId, { reduxPath: reduxPath, apiUrl: apiUrl }));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VideoAsset2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/lib/cjs/index.js
 ** module id = 182
 ** module chunks = 1
 **/